import { BlackjackEvents } from '../events/blackjack.js';

export interface SuspensionTrackerOptions {
  onChange?: (isSuspended: boolean) => void;
}

export class SuspensionTracker {
  private suspended = false;
  private readonly onChange?: (isSuspended: boolean) => void;

  constructor(options: SuspensionTrackerOptions = {}) {
    this.onChange = options.onChange;
  }

  handleEvent(event: { type?: string } | null | undefined): void {
    if (!event || typeof event.type !== 'string') return;
    const typed = event as BlackjackEvents.Event;
    if (BlackjackEvents.isBetTimerExpired(typed)) {
      this.setSuspended(true);
    } else if (BlackjackEvents.isBetConfirmation(typed)) {
      this.setSuspended(false);
    }
  }

  reset(): void {
    this.setSuspended(false);
  }

  getState(): { isSuspended: boolean } {
    return { isSuspended: this.suspended };
  }

  private setSuspended(next: boolean): void {
    if (this.suspended === next) return;
    this.suspended = next;
    this.onChange?.(next);
  }
}
